var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStakeLabel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#4909AA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8054 11.8785L15.639 5.82499C15.2884 5.31071 14.7212 5 14.1127 5C12.5761 5 11.6892 6.79999 12.5761 8.09641L15.5978 12.4999L12.5761 16.9035C11.6789 18.1999 12.5761 19.9999 14.1127 19.9999C14.7212 19.9999 15.2987 19.6892 15.6493 19.1749L19.8157 13.1214C20.0632 12.7464 20.0632 12.2535 19.8054 11.8785Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5865 11.8785L8.43037 5.82499C8.06942 5.31071 7.50221 5 6.89375 5C5.35712 5 4.45989 6.79999 5.35712 8.09641L8.37881 12.4999L5.35712 16.9035C4.45989 18.1999 5.35712 19.9999 6.89375 19.9999C7.50221 19.9999 8.07973 19.6892 8.43037 19.1749L12.5968 13.1214C12.8443 12.7464 12.8443 12.2535 12.5865 11.8785Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStakeLabel);
export default __webpack_public_path__ + "static/media/stake-label.775e99d2db6c5297fed35c40797cbe7d.svg";
export { ForwardRef as ReactComponent };